import { NgModule } from '@angular/core';

import { SubNavForCollapsedModule } from './forCollapsed';
import { SubNavForExpandedModule } from './forExpanded';
import { SubNavForMobileModule } from './forMobile';
import { SubNavLabelForMobileModule } from './subNavLabel';

const toExport: any[] = [
    SubNavForCollapsedModule,
    SubNavForExpandedModule,
    SubNavForMobileModule,
    SubNavLabelForMobileModule,
];

@NgModule({
    imports: [
        ...toExport,
    ],
    exports: [
        ...toExport,
    ],
})
export class SubNavTypesModule { }
